// extracted by mini-css-extract-plugin
export default {"menuTargetWrapper":"m10RNk","menuOptions":"wzGsaj","menuOption":"OYYQ_r","empty":"K6Wouh"};